import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

const Slider = React.forwardRef(({ 
  className, 
  trackClassName, 
  rangeClassName, 
  thumbClassName, 
  ...props 
}, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex w-full touch-none select-none items-center",
      className
    )}
    {...props}
  >
    <SliderPrimitive.Track
      className={cn(
        "relative h-1.5 w-full grow overflow-hidden rounded-full bg-primary/20",
        trackClassName
      )}
    >
      <SliderPrimitive.Range 
        className={cn("absolute h-full bg-primary", rangeClassName)} 
      />
    </SliderPrimitive.Track>
    {/* Support for single or multiple thumbs (range slider) */}
    {(props.value || props.defaultValue || [0]).map((_, i) => (
      <SliderPrimitive.Thumb
        key={i}
        className={cn(
          "block h-4 w-4 rounded-full border border-primary/50 bg-background shadow cursor-grab active:cursor-grabbing touch-none will-change-transform focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
          thumbClassName
        )}
      />
    ))}
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }